var _a;
import { Usage, DefaultPageBreakpoints } from './advert-image.types';
var DefaultPageBreakpointsList = [
    DefaultPageBreakpoints.Large,
    DefaultPageBreakpoints.Medium,
    DefaultPageBreakpoints.Small,
];
var UsageWidths = Object.freeze((_a = {},
    _a[Usage.Thumbnail] = {
        default: 260,
        srcSet: [260, 108, 84],
    },
    _a[Usage.Result] = {
        default: 480,
        srcSet: [480, 340, 260],
    },
    _a[Usage.Card] = {
        default: 600,
        srcSet: [600, 480, 340],
    },
    _a[Usage.Main] = {
        default: 800,
        srcSet: [800, 720, 600],
    },
    _a[Usage.Full] = {
        default: 1024,
        srcSet: [1024, 1024, 1024],
    },
    _a));
var getReplacedUrl = function (src, width) {
    var fileName = (src.match(/([^/]+)$/g) || [])[0] || '';
    return src.replace(/media\/.+$/, "media/w".concat(width, "/").concat(fileName));
};
export var generateSrcFromUsage = function (src, usage) {
    var width = UsageWidths[usage].default;
    return getReplacedUrl(src, width);
};
export var generateSrcSetFromUsage = function (src, usage, pageBreakpoints) {
    var usageWidths = UsageWidths[usage].srcSet;
    var widthPageBreakpointMapping = pageBreakpoints !== null && pageBreakpoints !== void 0 ? pageBreakpoints : Object.fromEntries(DefaultPageBreakpointsList.map(function (breakpoint, i) { return [usageWidths[i], breakpoint]; }));
    var normalisedUsages = usageWidths;
    var breakpoints = {};
    for (var width in widthPageBreakpointMapping) {
        if (normalisedUsages.includes(Number(width))) {
            var breakpoint = widthPageBreakpointMapping[width];
            breakpoints[breakpoint] = Number(width);
        }
    }
    var sortedBreakpoints = Object.keys(breakpoints).sort(function (a, b) { return Number(b) - Number(a); });
    return sortedBreakpoints.map(function (breakpoint) {
        return {
            media: "".concat(breakpoint, "px"),
            srcSet: [
                {
                    url: getReplacedUrl(src, breakpoints[Number(breakpoint)]),
                },
            ],
        };
    });
};
export var generateDimensionsFromUsage = function (usage) {
    var width = UsageWidths[usage].default;
    return {
        width: width,
        height: Math.floor((width / 4) * 3),
    };
};
